export const PICTURE_COMPREHENSION_RECOGNITION_MESSAGES = {
  CORRECT: '<correct tap>',
  INCORRECT: '<incorrect tap>',
} as const;
